import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { useSelector } from 'react-redux';
import { withConditionalFeatures } from '@americanexpress/conditional-features';
import getTealeafDetails from '../../selectors/tealeafSelectors';
import { hasTealeafRule } from '../../constants/featureConstants';

const Tealeaf = ({ hasTealeaf }) => {
  const { src: tealeafSrc } = useSelector((state) => getTealeafDetails(state, hasTealeaf));
  React.useEffect(() => {
    const tealeaf = document.createElement('script');
    tealeaf.setAttribute('type', 'text/javascript');
    tealeaf.setAttribute('src', tealeafSrc);
    document.body.appendChild(tealeaf);
    return () => {
      document.body.removeChild(tealeaf);
    };
  }, [tealeafSrc]);

  return null;
};

Tealeaf.propTypes = {
  hasTealeaf: PropTypes.bool.isRequired,
};

const mapFeaturesToProps = {
  hasTealeaf: hasTealeafRule,
};

const hocChain = compose(
  withConditionalFeatures({ mapFeaturesToProps })
);

export { Tealeaf as TestableTealeaf };

export default hocChain(Tealeaf);
